import { type ReactNode } from 'react';
import { FieldInput } from '@/components/ui/field-input';
import { fieldChange } from '../utils/field-change';
import type { RowProps } from './new-member-rows';

export function ContactRow({ data, onChange, errors }: RowProps): ReactNode {
  return (
    <>
      <FieldInput
        placeholder="Instagram personal (sin @)"
        value={data.personal_ig_username}
        onChange={fieldChange(data, onChange, 'personal_ig_username')}
        error={errors.personal_ig_username}
      />
      <FieldInput
        placeholder="Instagram de jugador (opcional, lo completa el jugador)"
        value={data.ig_username}
        onChange={fieldChange(data, onChange, 'ig_username')}
        error={errors.ig_username}
      />
      <FieldInput
        type="email"
        placeholder="Email"
        value={data.email}
        onChange={fieldChange(data, onChange, 'email')}
        error={errors.email}
      />
    </>
  );
}
